import { SagaIterator } from 'redux-saga'
import { all, call, put, takeLatest } from 'redux-saga/effects'

import { links } from '~/links'
import { onOtcPath } from '~/paths'
import { checkLoggedIn, logout } from './util/service'
import { checkIsBusinessUser } from './util/checkIsBusinessUser'
import { ACTIONS, expired, loggedInWithBusinessAccount, loginSuccess, InitalLoggedInUser } from './actions'

function* initialLoggedInUserSaga({ payload }: InitalLoggedInUser): SagaIterator {
  const { user } = payload

  if (user) {
    yield put(loginSuccess(user))
    if (checkIsBusinessUser(user)) {
      yield put(loggedInWithBusinessAccount())
    }
  } else {
    yield put(expired())
  }
}

function* logoutSaga(): SagaIterator {
  yield call(logout)
  if (onOtcPath()) {
    window.location.href = links.accountSignInLink()
  } else {
    window.location.href = `/pwa${links.shipmentLink()}`
  }
}

export function* redirectOtcOnExpired(): SagaIterator {
  // eslint-disable-next-line no-return-assign
  yield call(() => (window.location.pathname = links.accountSignInLink()))
}

export function* checkLoggedInUser(): SagaIterator {
  try {
    const { user } = yield call(checkLoggedIn)
    if (!user) {
      yield put(expired())
    }
  } catch {
    yield put(expired())
  }
}

export function* authenticationSaga() {
  yield all([
    takeLatest(ACTIONS.LOGOUT, logoutSaga),
    takeLatest(ACTIONS.INITIAL_LOGGED_IN_USER, initialLoggedInUserSaga),
    ...(onOtcPath() ? [takeLatest(ACTIONS.EXPIRED, redirectOtcOnExpired)] : []),
  ])
}
